import { AppState } from 'Store'

const selectIsEditing = (state: AppState) => state.profile.isEditing
const selectAvatarEditorFile = (state: AppState) => state.profile.avatarEditorFile

export const profileSelectors = { selectIsEditing, selectAvatarEditorFile }
